import { render, staticRenderFns } from "./civil-engineering-1.vue?vue&type=template&id=c8200126&"
import script from "./civil-engineering-1.vue?vue&type=script&lang=js&"
export * from "./civil-engineering-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports